import React, { useEffect, useState } from "react";
import Dwolla from "react-dwolla-iav";
import { API_URL } from "../../Config/config";
import { fetchApiData, displayLog } from "../../Helper/helper";
import { getClientToken } from "../../Services/dwolla";

const DwollaAddOwner = (props) => {


    const [dwolla, setDwolla] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    const [isAccountExists, setAccount] = useState(false);

    useEffect(async () => {
        await getDwollaUSerInfo()


        return () => {
            removeDwollaScript();
        };
    }, []);

    const initializeData = async () => {
        addDwollaScript();
    };

    const getDwollaUSerInfo = async () => {
        setLoading(true)
        let response = await fetchApiData(`${API_URL}/dwolla/get-dwolla-user-info`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response && !response.error) {
            setUserInfo(response.data)

            if (response.data.status != "verified") {

                displayLog("error", "Your account is not verified");
            }
            else {
                initializeData();
            }

        } else {
            displayLog("error", response.msg);
        }
        setLoading(false)
    }



    const addDwollaScript = async () => {
        setLoading(true);
        var script = document.createElement("script");
        script.id = "dwollaCustomer";
        // script.async = true;
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    configureDwolla();
                }
            };
        } else {
            script.onload = function () {
                configureDwolla();
            };
        }

        script.src = "//cdn.dwolla.com/v2.1.9/dwolla-web.js";
        document.getElementsByTagName("head")[0].appendChild(script);


    };

    const removeDwollaScript = async () => {
        const script = document.getElementById("dwollaCustomer");
        document.body.removeChild(script);
    };

    const configureDwolla = async () => {

        window.dwolla.configure({
            environment: "sandbox",
            styles: "/styles/update-custom.css",
            token: (req) => Promise.resolve(dwollaAPIToken(req, { blah: "abcd" })),
            success: (res) => Promise.resolve(onSuccess(res)),
            error: (err) => Promise.resolve(onError(err)),
        });
        setLoading(false);
        setDwolla(true);
    };

    function dwollaAPIToken(req, additional) {
        const tokenUrl = "/api/tokenUrl";
        const data = {
            action: req.action,
        };
        if (req.links) {
            data._links = req.links;
        }
        const headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "Dwolla-Drop-Ins-Library",
            "Access-Control-Allow-Origin": `${API_URL}`,
        };

        return fetch(`https://${API_URL}/dwolla/generate-token`, {
            credentials: "omit",
            method: "POST",
            body: JSON.stringify(data),
            headers,
        })
            .then((response) => {
                return response.json();
            })
            .then((result) => {

                return result;
            })
            .catch((error) => {

                return error;
            });
    }

    const onSuccess = async (data) => {
        /* do stuff with data */

        // var splitURL = data.response.location.toString().split("/");
        // const index = splitURL.length - 1
        // const customerId = splitURL[index]
        // let updateObj = {
        //     dwolloaLocationUrl: data.response.location,
        //     dwollaCustomerId: customerId,
        //     isDwolloBussinessAccountCreated: true
        // }
        // let response = await fetchApiData(`${API_URL}/dwolla/update-dwolla-status`, {
        //     method: "PUT",
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify(updateObj),
        // });

        // if (response && !response.error) {
        //     displayLog("success", "Your Dwolla Account is created successfully");
        //     navigate(-1);
        // } else {
        //     displayLog("error", response.msg);
        // }
        displayLog("success", "Your Dwolla Account is created successfully");
    };
    const onError = (err) => {
        /* handle err */
        displayLog("error", "Some thing went wrong");

    };

    return (
        <div className="account-settings auto-pricing">
            <h3>Add Add Owner</h3>
            <hr />
            <div className="account-settings-menu">
                {loading ? (
                    <div className="text-center"> Fetching data... </div>
                ) : (
                    <div className="row dwolla-content">
                        <div className="col-md-7 col-sm-12 col-xs-12">{dwolla ? <dwolla-beneficial-owners customerId={userInfo.id}>
                        </dwolla-beneficial-owners> : null}</div>
                    </div>
                )}

                {/* <Dwolla onSuccess={onSuccess} onError={onError} dwollaConfig={configureDwolla} /> */}
            </div>

        </div>
    );
};

export default DwollaAddOwner;
